import { HelpData, HelpInfo, HelpLinkInfo, HelpQuery, HelpQueryMessage } from "../autogenerated/ZoomBridge";
import StringUtil from "./StringUtil";
import { ThemeSetup } from '../themes/ThemeSetup';
/**
 * Will contain all the help keys which will be used across webclient.
 */
export const HelpKey = {
  HOME_PAGE: "Home_Page",
  BROWSE_ASSETS_PAGE: "Assets_Page",
  COLLECTIONS_PAGE: "Collections_Page",
  SEARCH_PAGE: "Search_Page",
  EXTERNAL_FILES_PAGE: "External_Files_Page",
  SETTINGS_PAGE: "Settings_Page",
}

export const HelpIconType = {
  SETTINGS_ICON: "Settings",
  INFORMATION_ICON: "Information",
  INTERLINK_ICON: "InterLink",
  RESOURCES_ICON: "Resources",
  USERS_ICON: "Users",
  ADD_VIDEO_ICON: "AddVideo",
  VIDEO_ICON: "Video",
  GLOBAL_ICON: "Global",
  MAIL_ICON: "Mail",
  COMMENT_BUBBLE_ICON: "CommentBubble",
  RIGHT_TICK_ICON: "RightTick",
  SAVE_FILE_ICON: "SaveFile",
  SEARCH_ICON: "Search",
  CLICKLINK_ICON: "ClickLink",
  NONE: "None"
}

export const IconPosition = {
  LEFT: "Left",
  RIGHT: "Right",
}

export const HelpType = {
  TEXT: "Text",
  LINK: "Link",
}

export default class HelpUtil {

  static DEFALUT_HELP_HEADER = "Help";
  static DEFAULT_HELP_URL = "https://help.evolphin.com/";

  /**
   * Return HelpKey based on action name provided.
   * @param {String} pageName Page name will be athe active tab for which user is trying to find help.
   */
  static getHelpKeyForPage(pageName): String {
    switch (pageName) {
      case 'HOME':
        return HelpKey.HOME_PAGE;
      case 'ASSETS':
        return HelpKey.BROWSE_ASSETS_PAGE;
      case 'COLLECTIONS':
        return HelpKey.COLLECTIONS_PAGE;
      case 'SEARCH':
        return HelpKey.SEARCH_PAGE;
      case 'SETTINGS':
        return HelpKey.SETTINGS_PAGE;
      case 'EXTERNAL_FILES':
        return HelpKey.EXTERNAL_FILES_PAGE;
      default:
        return null;
    }
  }

  /**
   * Return HelpKey based on action name provided.
   * @param {UiActions} uiAction uiAction name can be any specific action name for which user is trying to find help.
   */
  static getHelpKeyForAction(uiAction): String {
    switch (uiAction) {
      default:
        return null;
    }
  }

  static getHelpHeader(helpInfo: HelpInfo) {
    return helpInfo && helpInfo.getHelpHeader() ? helpInfo.getHelpHeader() : HelpUtil.DEFALUT_HELP_HEADER;
  }

  static getHelpType(helpInfo: HelpInfo, isChildItem: Boolean = false) {
    if (helpInfo && StringUtil.isNotEmpty(helpInfo.getHelpType()))
      return helpInfo.getHelpType();
    else {
      if (isChildItem)
        return HelpType.LINK;
      else
        return HelpType.TEXT;
    }
  }

  static getHelpUrlForChild(helpinfo: HelpInfo) {
    if (helpinfo && StringUtil.isNotEmpty(helpinfo.getHelpContent()) && HelpUtil.getHelpType(helpinfo, true) == HelpType.LINK)
      return helpinfo.getHelpContent();
    else {
      return DEFAULT_HELP_URL;
    }
  }

  static getHelpUrlForLink(linkItem: HelpLinkInfo) {
    if (linkItem && StringUtil.isNotEmpty(linkItem.getLinkUrl()))
      return linkItem.getLinkUrl();
    else {
      return DEFAULT_HELP_URL;
    }
  }

  static isHelpDataEmpty(helpData: HelpData): Boolean {
    return !helpData || (HelpUtil.isHelpInfoEmpty(helpData.getHelpInfo()) &&
      HelpUtil.isHelpItemsEmpty(helpData.getHelpItems()));
  }

  static isHelpDataNotEmpty(helpData: HelpData): Boolean {
    return !HelpUtil.isHelpDataEmpty(helpData);
  }

  static isHelpItemsEmpty(helpItems: Array<HelpInfo>): Boolean {
    return !helpItems || helpItems.length <= 0;
  }

  static isHelpItemsNotEmpty(helpItems: Array<HelpInfo>): Boolean {
    return !HelpUtil.isHelpItemsEmpty(helpItems);
  }

  static isHelpInfoEmpty(helpInfo: HelpInfo): Boolean {
    return !helpInfo || !helpInfo.getHelpContent();
  }

  static isHelpInfoNotEmpty(helpInfo: HelpInfo): Boolean {
    return !HelpUtil.isHelpInfoEmpty(helpInfo);
  }

  static getHelpIcon(iconType: HelpIconType, isLinkItem: Boolean = false): String {
    switch (iconType) {
      case HelpIconType.SETTINGS_ICON:
        return ThemeSetup.getImageURL('help/settings-icon.svg');
      case HelpIconType.INFORMATION_ICON:
        return ThemeSetup.getImageURL('help/information-icon.svg');
      case HelpIconType.INTERLINK_ICON:
        return ThemeSetup.getImageURL('help/interlink-icon.svg');
      case HelpIconType.RESOURCES_ICON:
        return ThemeSetup.getImageURL('help/resources-icon.svg');
      case HelpIconType.USERS_ICON:
        return ThemeSetup.getImageURL('help/users-icon.svg');
      case HelpIconType.ADD_VIDEO_ICON:
        return ThemeSetup.getImageURL('help/add-video-icon.svg');
      case HelpIconType.VIDEO_ICON:
        return ThemeSetup.getImageURL('help/video-icon.svg');
      case HelpIconType.COMMENT_BUBBLE_ICON:
        return ThemeSetup.getImageURL('help/comment-bubble-icon.svg');
      case HelpIconType.GLOBAL_ICON:
        return ThemeSetup.getImageURL('help/global-icon.svg');
      case HelpIconType.MAIL_ICON:
        return ThemeSetup.getImageURL('help/mail-icon.svg');
      case HelpIconType.RIGHT_TICK_ICON:
        return ThemeSetup.getImageURL('help/right-tick-icon.svg');
      case HelpIconType.SAVE_FILE_ICON:
        return ThemeSetup.getImageURL('help/save-file-icon.svg');
      case HelpIconType.SEARCH_ICON:
        return ThemeSetup.getImageURL('help/search-icon.svg');
      case HelpIconType.CLICKLINK_ICON:
        return ThemeSetup.getImageURL('help/click-link-icon.svg');
      default:
        return isLinkItem ? ThemeSetup.getImageURL('help/click-link-icon.svg') :
          ThemeSetup.getImageURL('help/information-icon.svg');
    }
  }
}
